import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { colors } from "common";
import { FlexBox } from "components/flex-box";
import LazyImage from "components/LazyImage";
import { H2, H6 } from "components/Typography";
import { FC } from "react";
import useWindowSize from "hooks/useWindowSize";

type Props = {
  isVisible: boolean;
};

export const OrderCreatingDialog: FC<Props> = ({ isVisible }) => {
  const width = useWindowSize();
  const isMobile = width <= 900;

  return (
    <Dialog open={isVisible} fullWidth={false} maxWidth="xs">
      <DialogContent>
        <FlexBox flexDirection="column" mt={1} alignItems="center">
          <LazyImage
            width={350}
            height={350}
            objectFit="contain"
            src={"/assets/images/kachi/kachi-building.png"}
          />

          <H2
            m={1}
            fontSize={isMobile ? 18 : 20}
            color={colors.success}
            textAlign="center"
          >
            Creating Order. Wait for a few moments while we process your order
          </H2>

          <H6 mb={2} display="inline">
            Please do not close this window or navigate away.
          </H6>

          <CircularProgress
            size={20}
            sx={{ color: colors.primary, margin: 3 }}
          />
        </FlexBox>
      </DialogContent>
    </Dialog>
  );
};
